import { Injectable } from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { first } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StepperService {
  private _stepper!: MatStepper;

  set stepper(stepper: MatStepper) {
    this._stepper = stepper;
  }

  get stepper() {
    return this._stepper;
  }

  previous() {
    const steps = this.stepper.steps;
    const currentStepIndex = this.stepper.selectedIndex;
    const previousStep = steps.get(currentStepIndex - 1);

    if (previousStep) {
      previousStep.editable = true;
      previousStep.completed = false;
    }

    this.stepper.previous();
  }

  next(injectedCallbackFn?: () => boolean) {
    this.stepper.selected?.stepControl.markAllAsTouched();

    if (injectedCallbackFn && injectedCallbackFn()) return;

    this.stepper.selectionChange.pipe(first()).subscribe((event) => {
      if (event.selectedIndex > event.previouslySelectedIndex) {
        const steps = this.stepper.steps;
        const currentStepIndex = this.stepper.selectedIndex;

        steps.forEach((step, index) => {
          if (index <= currentStepIndex) {
            step.editable = false;
            step.completed = true;
          } else {
            step.editable = true;
            step.completed = false;
          }
        });
      }
    });

    this.stepper.next();
  }
}
